<template>
  <el-dialog fullscreen :visible="isShow" :modal="false" :show-close="false" custom-class="dialog-form">
    <div slot="title" class="dialog-title-container">
      <span class="title-label"><i class="el-icon-document"></i> 样本册相关物料出入库汇总</span>
      <i class="el-icon-error" @click="close"></i>
    </div>
    <el-row class="form-top-btns">
      <el-button type="danger" size="mini" plain round icon="el-icon-close" @click="close">关闭</el-button>
    </el-row>
    <div class="form-container" style="top:28px">
      <el-form ref="form" :model="formData" size="mini" label-width="80px">
        <div style="height: 28px; padding-top: 5px;">
          <div style="width: 22%; height: 100%; float: left;">
            <div class="detail-header">
              <div class="detail-title"><i class="em-icon-th-list"></i> 样本册组成</div>
            </div>
          </div>
          <div style="border-box; padding:0 5px; width: 39%; height: 100%; float: left;">
            <div class="detail-header">
              <div class="detail-title"><i class="em-icon-th-list"></i> 原材料出入库</div>
            </div>
          </div>
          <div style="width: 39%; height: 100%; float: right;">
            <div class="detail-header">
              <div class="detail-title"><i class="em-icon-th-list"></i> 半成品出入库</div>
            </div>
          </div>
        </div>
        <div class="el-table-container form-details" style="top: 30px;">
          <div style="position: relative; width: 22%; height: 100%; float: left;">
            <el-table :data="formData.details" ref="detailTable" size="mini" height="100%" style="width: 100%; border:1px solid #d1d1d1;" border header-row-class-name="list-header-row" row-class-name="list-row" highlight-current-row @current-change="handlerChange">
              <el-table-column label="序号" type="index" width="47" align="center"></el-table-column>
              <el-table-column label="部品名称" prop="base_material_name" width="140" align="center"></el-table-column>
              <el-table-column label="单册数量" prop="number" width="60" align="center"></el-table-column>
              <el-table-column label="总数" prop="total_number" width="40" align="center"></el-table-column>
              <el-table-column label="备注" prop="remark" align="center"></el-table-column>
            </el-table>
          </div>
          <div style="position: relative; box-size: border-box; padding:0 5px; width: 39%; height: 100%; float: left;">
            <el-table :data="formData.materials" size="mini" height="100%" style="width: 100%; border:1px solid #d1d1d1;" border header-row-class-name="list-header-row" :row-class-name="tableRowClassName">
              <el-table-column label="序号" type="index" width="50" align="center"></el-table-column>
              <el-table-column label="日期" prop="date" width="120" align="center"></el-table-column>
              <el-table-column label="单号" prop="no" width="60" align="center"></el-table-column>
              <el-table-column label="数量" prop="number" width="60" align="center"></el-table-column>
              <el-table-column label="类型" prop="type" width="80" align="center"></el-table-column>
              <el-table-column label="备注" prop="remark" align="center"></el-table-column>
            </el-table>
          </div>
          <div style="position: relative; width: 39%; height: 100%; float: right;">
            <el-table :data="formData.halfs" size="mini" height="100%" style="width: 100%; border:1px solid #d1d1d1;" border header-row-class-name="list-header-row" :row-class-name="tableRowClassName">
              <el-table-column label="序号" type="index" width="47" align="center"></el-table-column>
              <el-table-column label="日期" prop="date" width="120" align="center"></el-table-column>
              <el-table-column label="单号" prop="no" width="60" align="center"></el-table-column>
              <el-table-column label="数量" prop="number" width="60" align="center"></el-table-column>
              <el-table-column label="类型" prop="type" width="80" align="center"></el-table-column>
              <el-table-column label="备注" prop="remark" align="center"></el-table-column>
            </el-table>
          </div>
        </div>
        <div class="form-footer">
          <div style="width: 22%;height: 100%; float: left;"></div>
          <div style="width: 39%;height: 100%; float: left;text-align: center">
             <span>原材料总入库数：{{materialsInCount}}</span>
             <span style="margin-left: 30px">原材料总出库数：{{materialsOutCount}}</span>
          </div>
          <div style="width: 39%;height: 100%; float: left;text-align: center">
             <span>半成品总入库数：{{halfInCount}}</span>
             <span style="margin-left: 30px">半成品总出库数：{{halfOutCount}}</span>
          </div>
        </div>
      </el-form>
    </div>
  </el-dialog>
</template>
<style>
.el-tag--mini {
   width: 90px;
}
.el-tag--mini .el-icon-close {
  float: right;
  margin-top: 1px;
}
.el-table .warning-row {
  background:oldlace;
}
.el-table .success-row {
  background: #f0f9eb;
}
</style>
<script>
export default {
  name: 'EzzShareDialogForm',
  props: {
    parent: {
      type: Object,
      default: () => null
    }
  },
  data: function () {
    return {
      // 当前子组件对话框的显隐
      isShow: false,
      formData: null,
      currentRow: [],
      materialsInCount: 0,
      materialsOutCount: 0,
      halfInCount: 0,
      halfOutCount: 0,
      formEmptyData: {
        id: '0',
        details: [],
        materials: [],
        halfs: []
      }
    }
  },
  created: function () {
    this.formData = JSON.parse(JSON.stringify(this.formEmptyData))
  },
  mounted: function () {
  },
  methods: {
    // 加载数据
    loadData: function () {
      let _this = this
      _this.post(_this.$apis.getProductSum, { ProductId: _this.formData.id }, function (res) {
        let _json = res.data
        if (_json.status && _json.status === 'logout') {
          _this.logout()
        } else {
          if (_json.formData != null) {
            _this.formData = _json.formData
            if (_this.formData.details.length > 0) {
              _this.$refs.detailTable.setCurrentRow(_this.formData.details[0])
            }
            _this.loadStores()
          } else {
            _this.formData = JSON.parse(JSON.stringify(_this.formEmptyData))
          }
        }
      })
    },
    // 加载原材料出入库数据
    loadStores: function () {
      let _this = this
      _this.post(_this.$apis.getProductStores, this.currentRow, function (res) {
        let _json = res.data
        if (_json.status && _json.status === 'logout') {
          _this.logout()
        } else {
          if (_json.materials != null) {
            _this.formData.materials = _json.materials
            _this.formData.halfs = _json.halfs
            _this.materialsInCount = 0
            _this.materialsOutCount = 0
            for (let i = 0; i < _json.materials.length; i++) {
              if (_json.materials[i].type === '原材料入库') {
                _this.materialsInCount += parseFloat(_json.materials[i].number)
              } else if (_json.materials[i].type === '原材料出库') {
                _this.materialsOutCount += parseFloat(_json.materials[i].number)
              }
            }
            _this.halfInCount = 0
            _this.halfOutCount = 0
            for (let i = 0; i < _json.halfs.length; i++) {
              if (_json.halfs[i].type === '半成品入库') {
                _this.halfInCount += parseFloat(_json.halfs[i].number)
              } else if (_json.halfs[i].type === '半成品出库') {
                _this.halfOutCount += parseFloat(_json.halfs[i].number)
              }
            }
          } else {
            _this.formData.materials = []
            _this.formData.halfs = []
          }
        }
      })
    },
    close: function () {
      this.$confirm('确定关闭？', '提示', {})
        .then(_ => {
          this.isShow = false
        })
        .catch(_ => {
          return false
        })
    },
    handlerShare: function (formId) {
      this.formData.id = formId
      this.loadData()
      this.isShow = true
    },
    handlerChange: function (_newRow, _oldRow) {
      this.currentRow = _newRow
      this.loadStores()
    },
    // 行颜色变化
    tableRowClassName ({ row, rowIndex }) {
      if (row.type === '原材料入库' || row.type === '半成品入库') {
        return 'warning-row'
      } else {
        return 'success-row'
      }
    }
  },
  components: {
  }
}
</script>
